<template>
  <div>
    <v-card>
      <v-card-title>
            <h2>Client Details</h2>
            <v-btn
              fab
              dark
              small
              @click="$emit('toggle-info-displayer')"
              color="blue-grey lighten-2"
              class="ml-auto"
            >
              <v-icon>close</v-icon>
            </v-btn>
      </v-card-title>

      <v-divider color="#42A5F5"></v-divider>

        <v-container>
          <v-img :src="clientInfo.logo" class="center"></v-img>
        </v-container>

      <v-container container--fluid grid-list-md pt-0>
         <v-row justify="center">
          <v-col cols="12" md="10">
            <v-container container--fluid grid-list-md>
               <v-row justify="center" align="center"
                        v-for="(key, index) in Object.keys(clientInfo)"
                        v-if="key !== 'logo'"
                        :key="index">
                <v-col cols="6" class="py-1" tag="strong">{{formatKey(key)}}</v-col>
                <v-col cols="6" class="py-1 text-right">
                  <div>
                  {{clientInfo[key]}}
                  </div>
                </v-col>
                <v-col cols="10">
                  <v-divider></v-divider>
                </v-col>
               </v-row>
            </v-container>
          </v-col>
         </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: "ClientDisplayer",
    props: {
      clientInfo: Object,
    },
    data() {
      return {
        info: {
          name: 'Name:',
          street1: 'Address:',
          region_name: 'Region:',
          date: 'Scheduled Date:',
          tracking: 'Tracking Number:',
          invoice: 'Invoice Number:',
          instructions: 'Instructions:',
          client_name: 'Client Name:',
          status: 'Status:',
        },
      }
    },

    methods: {
      formatKey(key) {
        let listWords = key.split('_');
        for (var i = 0; i < listWords.length; i++) {
          let firstLetter = listWords[i].charAt(0);
          firstLetter = firstLetter.toUpperCase();

          let stringWithoutFirstLetter = listWords[i].slice(1);

          listWords[i] = firstLetter + stringWithoutFirstLetter;
        }
        let formattedKey = listWords.join(' ');
        return formattedKey
      }
    },
  }
</script>

<style scoped>
  .center {
    margin-left: auto;
    margin-right: auto;
    width: 150px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/Zones/ClientDisplayer.vue